// @ts-check
import angular from 'angular'

import controller from './settings.ctrl'
import template from './settings.html'

import crewProfileController from '../profile-webview/controller.js'
import crewProfileTemplate from '../profile-webview/template.html'
import '../profile-webview/style.css'

import profileController from './profile/profile.controller.js'
import profileTemplate from './profile/profile.html'
import referralsController from './referrals/referrals.ctrl.js'
import referralsTemplate from './referrals/referrals.html'
import { UsersController } from './users/viewUsers.ctrl.js'
import usersTemplate from './users/viewUsers.html'
import invoicesController from './invoices/controller.js'
import invoicesTemplate from './invoices/template.html'
import billingInfoController from './billing-info/controller.js'
import billingInfoTemplate from './billing-info/template.html'

import './settings.css'
import menu from './menu.html'
import mainMenu from '../../shared/menu/menu.html'
import { CLIENTS_USER_GROUP } from '../../constants'

export default angular.module('settings', ['ui.router'])
  .directive('mdtCustomCellInvoice', function () {
    return {
      template: '<md-button class="md-primary" aria-label="invoice Pdf"><md-icon>picture_as_pdf</md-icon></md-button>'
    }
  })
  .directive('mdtCustomCellAttach', function () {
    return {
      template: '<md-button class="md-primary" aria-label="invoice line items"><md-icon>attachment</md-icon></md-button>'
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.settings', {
      url: '/settings',
      resolve: {
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        },
        user: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        }
      },
      views: {
        content: {
          template,
          controller,
          controllerAs: 's'
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
    .state('app.settings.profile', {
      parent: 'app.settings',
      url: '/profile',
      resolve: {
        user: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        }
      },
      template: profileTemplate,
      controller: profileController,
      controllerAs: 'p'
    })
    .state('app.settings.crewProfile', {
      parent: 'app.settings',
      url: '/crewProfile?tab',
      template: crewProfileTemplate,
      controller: crewProfileController,
      controllerAs: 'ctrl'
    })
    .state('app.settings.users', {
      parent: 'app.settings',
      url: '/users',
      resolve: {
        users: (Companies) => {
          'ngInject'
          return Companies.fetchCompanyUsers(undefined, CLIENTS_USER_GROUP) //passing undefined for company id, endpoint will fetch it from user data
        },
        user: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        },
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        },
        regions: (Region) => {
          'ngInject'
          return Region.getRegions()
        }
      },
      template: usersTemplate,
      controller: UsersController,
      controllerAs: 'u'
    })
    .state('app.settings.invoices', {
      parent: 'app.settings',
      url: '/invoices',
      resolve: {
        invoices: (Companies, company) => {
          'ngInject'
          return Companies.getInvoiceData(company.internal_id)
        }
      },
      template: invoicesTemplate,
      controller: invoicesController,
      controllerAs: 'ctrl'
    })
    .state('app.settings.billingInfo', {
      parent: 'app.settings',
      url: '/billing',
      template: billingInfoTemplate,
      controller: billingInfoController,
      controllerAs: 'ctrl'
    })
    // We are temporarily disabling Referrals page while the campaign is paused.
    // We will enable it back once the campaign is back alive.
    // .state('app.settings.referrals', {
    //   parent: 'app.settings',
    //   url: '/referrals',
    //   resolve: {
    //     user: (Auth) => {
    //       'ngInject'
    //       return Auth.getDetails()
    //     },
    //     company: (Companies) => {
    //       'ngInject'
    //       return Companies.getCompanyData()
    //     },
    //     branchData: ($stateParams, $window) => {
    //       'ngInject'
    //
    //       return new Promise(resolve => {
    //         if (!$window.branch) return resolve(null)
    //
    //         $window.branch.init(CONFIG.BRANCH_KEY, (err, res) => {
    //           if (err) {
    //             console.log(err)
    //             return resolve(null)
    //           }
    //
    //           return resolve(res.data_parsed)
    //         })
    //       })
    //     }
    //   },
    //   template: referralsTemplate,
    //   controller: referralsController,
    //   controllerAs: 'u'
    // })
  })
